import { defineMessages } from 'react-intl';

export default defineMessages({
  light: {
    id: 'bitkit.navigation.accountMenu.themeSelector.light.option',
    defaultMessage: 'Light',
    description: 'Label for the theme switcher light option',
  },
  dark: {
    id: 'bitkit.navigation.accountMenu.themeSelector.dark.option',
    defaultMessage: 'Dark',
    description: 'Label for the theme switcher dark option',
  },
  matchBrowser: {
    id: 'bitkit.navigation.accountMenu.themeSelector.matchBrowser.option',
    defaultMessage: 'Match browser',
    description: 'Label for the theme switcher match browser option',
  },
  title: {
    id: 'bitkit.navigation.accountMenu.themeSelector.themeButton',
    defaultMessage: 'Theme',
    description:
      'Label for button in the account menu to switch to a different theme',
  },
  feedbackMessage: {
    id: 'bitkit.navigation.accountMenu.themeSelector.feedbackMessage',
    defaultMessage: 'Got feedback? {link}',
    description: 'Label for feedback survey',
  },
  feedbackMessageLink: {
    id: 'bitkit.navigation.accountMenu.themeSelector.feedbackMessageLink',
    defaultMessage: 'Let us know.',
    description: 'Link to open theme selector feedback modal',
  },
  giveFeedbackTitle: {
    id: 'bitkit.navigation.accountMenu.themeSelector.giveFeedbackTitle',
    description: 'Text for button to open feedback modal',
    defaultMessage: 'Give feedback',
  },
  giveFeedbackPlaceholder: {
    id: 'bitkit.navigation.accountMenu.themeSelector.giveFeedbackButtonPlaceholder',
    description: 'Text for placeholder in give feedback modal',
    defaultMessage: "Let us know what's on your mind",
  },
  giveFeedbackTitleDetailsOne: {
    id: 'bitkit.navigation.accountMenu.themeSelector.giveFeedbackTitleDetailsOne',
    description: 'Text for title details in give feedback modal',
    defaultMessage:
      'Your thoughts are valuable in helping improve our products',
  },
  giveFeedbackTitleDetailsTwo: {
    id: 'bitkit.navigation.accountMenu.themeSelector.giveFeedbackTitleDetailsTwo',
    description: 'Text for title details in give feedback modal',
    defaultMessage:
      "If you're looking to get help or want to report a bug, visit our {supportSiteLink}",
  },
  supportSiteLinkText: {
    id: 'bitkit.navigation.accountMenu.themeSelector.supportSiteLink',
    description: 'Link to support site',
    defaultMessage: 'support site.',
  },
  canContactLabel: {
    id: 'bitkit.navigation.accountMenu.themeSelector.canContactLabel',
    description: 'Text for the contact label',
    defaultMessage:
      'Atlassian can contact me about this feedback. See our {privacyPolicyLink}',
  },
  privacyPolicyLinkText: {
    id: 'bitkit.navigation.accountMenu.themeSelector.privacyPolicyLink',
    description: 'Link to privacy policy',
    defaultMessage: 'privacy policy',
  },
  enrollLabel: {
    id: 'bitkit.navigation.accountMenu.themeSelector.enrollLabel',
    description: 'Text for the enroll label',
    defaultMessage:
      "I'd like to help improve Atlassian products by joining the {atlassianResearchGroupLink}",
  },
  atlassianResearchGroupLinkText: {
    id: 'bitkit.navigation.accountMenu.themeSelector.atlassianResearchGroupLink',
    description: 'Link to Atlassian Research Group',
    defaultMessage: 'Atlassian Research Group',
  },
  feedbackSubmitFlagText: {
    id: 'bitkit.navigation.accountMenu.themeSelector.feedbackSubmitText',
    description: 'Text for feedback submission flag',
    defaultMessage:
      'Your valuable feedback helps us continually improve our products',
  },
  feedbackSubmitFlagTitle: {
    id: 'bitkit.navigation.accountMenu.themeSelector.feedbackSubmitTitle',
    description: 'Title for feedback submission flag',
    defaultMessage: 'Thanks',
  },
  onboardingIntroTitle: {
    id: 'bitkit.navigation.accountMenu.themeSelector.onboardingIntroTitle',
    description: 'Title for Theme Selector Onboarding Experience Intro Card',
    defaultMessage: 'Dark theme is here',
  },
  onboardingIntroDescription: {
    id: 'bitkit.navigation.accountMenu.themeSelector.onboardingIntroDescription',
    description:
      'Description for Theme Selector Onboarding Experience Intro Card',
    defaultMessage: 'Give Bitbucket a new look with our light & dark themes.',
  },
  onboardingNextTitle: {
    id: 'bitkit.navigation.accountMenu.themeSelector.onboardingNextTitle',
    description: '',
    defaultMessage: 'Set themes',
  },
  onboardingNextDescription: {
    id: 'bitkit.navigation.accountMenu.themeSelector.onboardingNextDescription',
    description: '',
    defaultMessage: 'Go dark, stay with light, or match your browser settings.',
  },
  onboardingDismissedButton: {
    id: 'bitkit.navigation.accountMenu.themeSelector.onboardingDismissedButton',
    description: '',
    defaultMessage: 'Dismiss',
  },
  onboardingNextButton: {
    id: 'bitkit.navigation.accountMenu.themeSelector.onboardingNextButton',
    description: '',
    defaultMessage: 'Next',
  },
  onboardingOkButton: {
    id: 'bitkit.navigation.accountMenu.themeSelector.onboardingOkButton',
    description: '',
    defaultMessage: 'OK',
  },
  onboardingGoBackButton: {
    id: 'bitkit.navigation.accountMenu.themeSelector.onboardingGoBackButton',
    description: '',
    defaultMessage: 'Go back',
  },
});
